import { useMemo } from 'react'

import { useZervantSettings } from '@features/invoicingSettings/hooks/useZervantSettings'
import { useZervantInvoiceLogoUrl } from '@features/invoicingSettings/modules/logoAndBranding'
import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useCurrentUser } from '@modules-deprecated/app/user/currentUserContext'

import { getDefaultTradeNameLogoId } from '../utils/getDefaultTradeNameLogoId'

export const usePredefinedInvoicesStepValues = () => {
  const { user } = useCurrentUser()
  const { isLoading: isLoadingOrganization, organization } = useUserOrganization()

  const { data: zervantSettings, isLoading: isLoadingSettings } = useZervantSettings()
  const { logoUrl: zervantLogoUrl, isLoading: isLoadingZervantLogo } = useZervantInvoiceLogoUrl()

  const isLoading = isLoadingOrganization || isLoadingSettings || isLoadingZervantLogo

  const logoId = useMemo(() => getDefaultTradeNameLogoId(zervantSettings?.values), [zervantSettings])

  const legalStatus = useMemo(() => zervantSettings?.values?.company?.legalStatus ?? undefined, [zervantSettings])

  const predefinedValues = useMemo(() => {
    if (isLoading) {
      return undefined
    }

    // The backend sets organization.name to the email local part (before @) as a registration fallback.
    const isOrgNameEmailFallback = organization?.name === user?.email?.split('@')[0]

    const company = {
      city: organization?.city ?? '',
      legalStatus,
      name: isOrgNameEmailFallback ? '' : (organization?.name ?? ''),
      registrationNo: organization?.registrationNo ?? '',
      street: organization?.street ?? '',
      vatNo: organization?.vatNo ?? '',
      zipcode: organization?.zipcode ?? '',
    }

    return {
      company,
      companyLogo: zervantLogoUrl && logoId ? { url: zervantLogoUrl, fileId: logoId } : null,
    }
  }, [isLoading, legalStatus, logoId, organization, user?.email, zervantLogoUrl])

  return {
    isLoading,
    predefinedValues,
  }
}
